import { AxiosInstance } from 'axios';
import { Stage } from './issues';

/** One part of an incident: a kind of error or an environment. Mirrors IncidentPartDto. */
export interface IncidentPart {
    key: string;
    title: string;
    count: number;
    open: number;
}

/** A message of an incident that is still open. Mirrors IncidentIssueDto. */
export interface IncidentIssue {
    customer: string;
    environment: string;
    key: string;
    objectType: string;
    relationId: string;
    status: string;
    code: string;
    firstFailedAt?: string | null;
}

/** A stretch of time Exact was out of reach, across the environments. Mirrors IncidentDto. */
export interface Incident {
    id: string;
    start: string;
    end: string;
    title: string;
    count: number;
    resolved: number;
    open: number;
    /** Failures per minute from the start, for a small chart. */
    perMinute: number[];
    codes: IncidentPart[];
    environments: IncidentPart[];
    openIssues: IncidentIssue[];
}

export interface Incidents {
    from: string;
    to: string;
    incidents: Incident[];
}

export const getIncidents = async (axios: AxiosInstance, days: number, stage?: Stage | '', signal?: AbortSignal): Promise<Incidents> => {
    const response = await axios.get(`/Issues/incidents?days=${days}${stage ? `&stage=${stage}` : ''}`, { signal });

    // The generated client's axios instance hands the body back as text.
    return (typeof response.data === 'string' ? JSON.parse(response.data) : response.data) as Incidents;
};
